export const ultimasNoticias = [
    
   //   {
   //      "imagen" : "assets/imgs/comisionpermanente.jpeg",

   //      "url" : "https://www.facebook.com/photo.php?fbid=1141667654661088&set=pb.100064535929070.-2207520000&type=3&locale=es_LA",
   //      "titulo" : "Contralores México",
       
   //     "fecha" : "Contralores México",
   //   }, 
   //   {
   //      "imagen" : "assets/imgs/CONTRALORIASOCIAL12.jpg",

   //      "url" : "https://www.facebook.com/share/p/1F7xuoj15B/",
   //      "titulo" : "Premio Nacional de Contralores ",
       
   //     "fecha" : "Contraloría Social",
   //   }, 


   //   {
   //      "imagen" : "assets/imgs/convocsatorias (2).jpg",
   //      "url" : "https://s-contraloria.hidalgo.gob.mx/interes/Convocatoria-Transparencia-en-Corto-2025.pdf",

   //      "titulo" : "Premio Nacional de Contralores ",
   //       "fecha" : "Contraloría Social",
   //  }, 

 {
    "imagen" : "assets/imgs/auditoria-up-energia.jpg",
    "url" : "https://www.facebook.com/share/p/1Rs3Dvmqu",
    "titulo" : "Secretaría de Contraloría Hidalgo",
    "fecha" : "La auditoría a la UP de la Energía llegó a su etapa de cierre, con la presentación de los resultados obtenidos y la definición de observaciones para su atención. Con estos procesos reforzamos la revisión, el control y la rendición de cuentas en las instituciones públicas. #ElHidalgoQueQueremos #AuditoriaPublica",
},
{
    "imagen" : "assets/imgs/omitlan-contraloria-social.jpg",
    "url" : "https://www.facebook.com/share/p/1DAoiPR5w",
    "titulo" : "Secretaría de Contraloría Hidalgo",
    "fecha" : "En #Omitlán fortalecemos la participación ciudadana con capacitación a los Comités de Contraloría Social y la entrega de chalecos y cascos para apoyar su labor de vigilancia. Con ciudadanía activa, promovemos la transparencia y el uso responsable de los recursos públicos. #ElHidalgoQueQueremos #ContraloriaSocial",
},
{
    "imagen" : "assets/imgs/xochiatipan-contraloria-social.jpg",
    "url" : "https://www.facebook.com/SecretariaContraloriaHgo/posts/pfbid025iS2DGCXrvt6MRTBmJ1u2V68FZVWpU84P9kMMHdowSBiFQeFKHqpiFwYW2v27ykNl?rdid=ZPkISm5Ds0n6sWZc#",
    "titulo" : "Secretaría de Contraloría Hidalgo",
    "fecha" : "En #Xochiatipan, fortalecemos la capacitación de los Comités de Contraloría Social para impulsar una vigilancia ciudadana activa sobre las obras y programas públicos. Con participación informada, promovemos la transparencia, la honestidad y el uso responsable de los recursos en beneficio de las comunidades. #ElHidalgoQueQueremos",
},
{
    "imagen" : "assets/imgs/san-felipe-orizatlan-contraloria-social.jpg",
    "url" : "https://www.facebook.com/share/p/19baiSvQDZ",
    "titulo" : "Secretaría de Contraloría Hidalgo",
    "fecha" : "En #SanFelipeOrizatlán, los Comités de Contraloría Social recibieron capacitación para fortalecer su labor de vigilancia y seguimiento de los recursos públicos y las obras en sus comunidades. 🤝 Con participación ciudadana, reforzamos la transparencia y el bienestar de las familias orizatlenses. #ElHidalgoQueQueremos #ContraloriaSocial",
},
{
    "imagen" : "assets/imgs/cocodi-segundo-trimestre-2026.jpg",
    "url" : "https://www.facebook.com/share/p/1EnW3ZQjW",
    "titulo" : "Secretaría de Contraloría Hidalgo",
    "fecha" : "📊 El seguimiento al desempeño institucional es clave para fortalecer el control interno. En sesión del COCODI se presentaron los resultados del segundo trimestre de 2026 y se revisaron las acciones prioritarias. 🔎 También se dio seguimiento a la administración de riesgos, la transparencia y el cumplimiento de los objetivos institucionales. #ElHidalgoQueQueremos",
},
{
    "imagen" : "assets/imgs/padron-proveedores-contratistas.jpg",
    "url" : "https://www.facebook.com/share/p/1NbwQybAw",
    "titulo" : "Secretaría de Contraloría Hidalgo",
    "fecha" : "La Contraloría revisa la documentación de personas físicas y morales que buscan formar parte del Padrón de Proveedores y Contratistas. 🔎 Validamos el cumplimiento de los requisitos para contar con registros confiables y procesos con mayor certeza y legalidad. #ElHidalgoQueQueremos #ProveedoresYContratistas",
},
 
 
 
    // {
    //     "imagen" : "noticias/comision.gif",
    //      "url" : "https://comisioncontralores.gob.mx/2023/",
    //     "titulo" : "Comisión Permanente de Contralores ",
    //    "fecha" : "Estados-Federación",
    // },     

    // {
    //     "imagen" : "noticias/9_jornada.jpg",
    //      "url" : "https://www.facebook.com/SecretariaContraloriaHgo/videos/1141123597339219/?mibextid=rS40aB7S9Ucbxw6v",
    //     "titulo" : "9 JORNADA DE CAPACITACIÓN ",
    //    "fecha" : "PARA LA TRANSFORMACIÓN DE HIDALGO",
    // },
    // {
    //     "imagen" : "noticias/convenio.jpg",
    //     "url" : "https://www.facebook.com/SecretariaContraloriaHgo/videos/1156571106119065",
    //     "titulo" : "Firma de Convenio de Donación de Sistemas por la Secretaría de la Honestidad ",
    //     "fecha" : "y la Secretaría de Contraloría de Hidalgo."
    // },
   


    // {
    //     "imagen" : "noticias/2da sesion.png",
    //     "url" : "https://www.facebook.com/share/p/14qTV3iovd/?mibextid=WC7FNe",
    //     "titulo" : " Segunda Asamblea Plenaria de la Comisión Permanente de Contralores Estado-Municipios",
    //     "fecha" : "28 de noviembre del 2024"
    // },



]